module.exports = __webpack_public_path__ + "static/media/about-illustration-2.6aad55df.svg";